import store from '../store';
import CelaneseAPI from './../services';
import config from './../config';

export const loggedState = logged => {
    console.log("logged state");
    return {
        type: 'LOGGED_STATE',
        logged
    };
};

export const userProfileData = prefData => {
    return {
        type: 'USER_PROFILE_DATA',
        prefData
    };
};

export const userRoleInfo = userRole => {
    return {
        type: 'USER_ROLE_INFO',
        userRole
    };
};

export const userPreferencesUpdated = preferences => {
    return {
        type: 'SET_USER_PREFERENCES',
        preferences
    }
}

export const towItemsData = itemData => {
    return {
        type: 'TOW_ITEMS_DATA',
        itemData
    };
};

export const getLoggedUser = (loginToken) => {
    return {
        type: 'GET_LOGGED_USER',
        loginToken
    };
}

export const loadTowItems = (towItemFormData) => {
    return {
        type: 'LOAD_TOW_ITEMS',
        towItemFormData
    };
}

export const towItemsSelected = (selectedTowItems) => {
    return {
        type: 'TOW_ITEMS_SELECTED',
        selectedTowItems
    }
}

export const isProfileLoaded = (profileLoaded) => {
    return {
        type: 'LOAD_PROFILE_DATA',
        profileLoaded
    };
}

export const login = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            store.dispatch({
                type: 'SET_LOGGED_USER',
                logged: true
            })
            resolve()
        }, 500)
    })
}

export const logout = () => {
    return new Promise((resolve) => {
        // localStorage.removeItem('token');
        // sessionStorage.removeItem('towItemSelectionData')
        store.dispatch({
            type: 'SET_LOGGED_USER',
            logged: false
        });
        resolve();
    });
}


/*********       Filters, Cigarette, EPD, Plugwrap Actions       **********/

export const getFiltersData = () => {
    return CelaneseAPI.get(config.API.filters).then(res => {
        if(res.data) {
            store.dispatch({
                type: 'FILTERS_DATA',
                filtersData: res.data
            });
        }
        return res;
    })
};

export const getCarbonFiltersData = () => {
    return CelaneseAPI.get(config.API.carbonFilters).then(res => {
        if(res.data) {
            store.dispatch({
                type: 'CARBON_FILTERS_DATA',
                carbonFiltersData: res.data
            });
        }
        return res;
    })
}

export const getCigaretteData = () => {
    return CelaneseAPI.get(config.API.cigarette).then(res => {
        if(res.data) {
            store.dispatch({
                type: 'CIGARETTE_DATA',
                cigaretteData: res.data
            });
        }
        return res;
    })
}

export const getCarbonCigaretteData = () => {
    return CelaneseAPI.get(config.API.carbonCigarette).then(res => {
        if(res.data) {
            store.dispatch({
                type: 'CARBON_CIGARETTE_DATA',
                carbonCigaretteData: res.data
            });
        }
        return res;
    })
}

export const getPlugwrapData = () => {
    return CelaneseAPI.get(config.API.plugwrap).then(res => {
        if(res.data) {
            store.dispatch({
                type: 'PLUGWRAP_DATA',
                plugwrapData: res.data
            });
        }
        return res;
    })
}

export const getEpdData = () => {
    return CelaneseAPI.get(config.API.epdBias).then(res => {
        if(res.data) {
            store.dispatch({
                type: 'EPD_DATA',
                epdData: res.data
            });
        }
        return res;
    })
}

export const getCompaniesData = () => {
    return CelaneseAPI.get(config.API.companies).then(res => {
        if(res.data) {
            store.dispatch({
                type: 'COMPANY_DATA',
                companiesData: res.data
            });
        }
        return res;
    })
}

export const getLanguagesData = () => {
    return CelaneseAPI.get(config.API.languageTranslations).then(res => {
        if (res.data) {
            store.dispatch({
                type: 'LANGUAGE_DATA',
                languagesData: res.data
            });
        }
        return res;
    });
}

export const getLanguagesCodes = () => {
    return CelaneseAPI.get(config.API.languageCodes).then(res => {
        if (res.data) {
            store.dispatch({
                type: 'LANGUAGE_CODES',
                languageCodes: res.data
            });
        }
        return res;
    });
}

export const getLocaleTranslationData = locale => {
    locale = locale || 'en';
    return CelaneseAPI.get(config.API.languageTranslationsById.replace(':id', locale)).then(res => {
        if (typeof res === 'object') {
            store.dispatch({
                type: 'TRANSLATION_DATA',
                translationData: res
            });
        }
        return res;
    });
}


// WEBPACK FOOTER //
// ./src/actions/index.js